export default "__VITE_ASSET__D4FecUv3__"